<template>
  <v-app-bar>
    <template #prepend>
      <v-app-bar-nav-icon
        icon="mdi-home"
        :to="{ name: '/' }"
      ></v-app-bar-nav-icon>
    </template>
    <v-app-bar-title>{{ title }}</v-app-bar-title>
    <template #append><slot></slot></template>
  </v-app-bar>
</template>
<script setup lang="ts">
defineProps<{
  title: string;
}>();
</script>
